import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text, useMedia } from '../../../../../components/Boneyard';
import { withValue } from '@g4/automation-hooks';
import { FLIGHTS_ROUND_TRIP_DISCOUNT } from '../../../../../../automationHooks.json';
import Markdown from '../../../../../components/Markdown';
import styled from 'styled-components';
import { useTranslations } from '../../../../../graphql/components/TranslationsProvider';

const DisclaimerText = styled(Text)`
  text-align: center;
  ${props => props.theme.query.md} {
    text-align: right;
  }
`;

const propTypes = {
  leg: PropTypes.string.isRequired,
};

const SubHeaderContent = props => {
  const mq = useMedia();
  const translations = useTranslations();

  // Todo:
  // The pr={2} doesn't is not aligned when page has no background
  // Need to use check if bg img is present via a global hook useSiteLayoutBackground
  // And switch usage of pr={2} based on it.
  return (
    <Box
      d="flex"
      justifyContent={mq.lt('md') ? 'center' : 'flex-end'}
      pb={2}
      pr={2}
      pt={2}
    >
      <DisclaimerText
        size={mq.lt('sm') ? 12 : 18}
        automationHook={withValue(
          FLIGHTS_ROUND_TRIP_DISCOUNT.hook,
          props.leg + '-disclaimer'
        )}
        weight={500}
      >
        {
          <Markdown
            source={translations.flightsPage.roundTripDiscountDisclaimerText}
          />
        }
      </DisclaimerText>
    </Box>
  );
};

SubHeaderContent.propTypes = propTypes;
SubHeaderContent.displayName = 'SubHeaderContent';
export default props => <SubHeaderContent {...props} />;
